import { render, staticRenderFns } from "./OrderChangelog.vue?vue&type=template&id=88d1e062&scoped=true&"
import script from "./OrderChangelog.vue?vue&type=script&lang=js&"
export * from "./OrderChangelog.vue?vue&type=script&lang=js&"
import style0 from "./OrderChangelog.vue?vue&type=style&index=0&id=88d1e062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1e062",
  null
  
)

/* custom blocks */
import block0 from "./OrderChangelog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports